import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function outcomes() {
  return (
    <section className="outcome p-100 text_peanut">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              What were the <span>Results?</span> 
            </h2>
            <p>
              The app was delivered after completion, and it exceeded the
              client’s expectations. It’s an innovative and interactive dog
              application, making it well-received among users as well.
            </p>
            <div className="outcome_img">
              <StaticImage
                src="../../../images/case-studies/peanut/result_outcome.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1063}
                height={651}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default outcomes;
